class ReportPageService {
  /**
   * Get layout blocks, filtering out any title blocks, which is a legacy case of reports having title blocks
   * saved to the database.
   */
  initializeLayoutBlocks (layout) {
    if (layout && layout.blocks && layout.blocks.length > 0) {
      const blocks = layout.blocks.filter((block) => block.key !== 'title' && !block.props?.placeholder)
      return this.moveChildBlocksToParent(blocks)
    }

    return []
  }

  /**
   * Extract child blocks in the flat block list and nest them inside their corresponding parent block
   * The flat block list is useful for editing, but we convert to the nested structure to make it easier for rendering
   */
  moveChildBlocksToParent (layoutBlocks = []) {
    const blocks = []
    const childBlocks = []

    layoutBlocks.forEach((block) => {
      if (block.props && block.props.parentBlock) {
        childBlocks.push(block)
      } else {
        blocks.push(block)
      }
    })

    // Push the children into a childBlocks prop on it's parent so the parent can manage rendering it's children
    childBlocks.forEach((childBlock) => {
      const parentBlock = blocks.find(({ key }) => key === childBlock.props.parentBlock.key)
      if (parentBlock) {
        parentBlock.props = { ...(parentBlock.props || {}) }
        parentBlock.props.childBlocks = parentBlock.props.childBlocks || []
        parentBlock.props.childBlocks.push(childBlock)
      }
    })

    return blocks
  }

  /**
   * Find a block in the given scrollable element and scroll to it if it exists
   *
   * @param {object} ref React ref which points to a scrollable element containing blocks
   * @param {string} blockKey The block key (or `page-title` & `page-description` for title and description page elements)
   */
  scrollToBlock (ref, blockKey) {
    if (!ref.current) {
      return
    }
    const block = ref.current.querySelector(`[data-block-key="${blockKey}"]`)
    if (block) {
      block.scrollIntoView({ behavior: 'auto', block: 'start' })
    }
  }
}

export const reportPageService = new ReportPageService()
